import './_page.scss';
import Forms from "./forms/forms";
import {DetailModel} from "../index";
import Summary from "./summary/summary";

interface PageProps {
    isSummaryPage: boolean
}

export default function Page({isSummaryPage} : PageProps) {
        return (
        <section className="page">
            {
                isSummaryPage ? <div className='w-100 h-100 p-3 d-flex flex-column '>
                    <h1 className='text-center'>Zusammenfassung</h1>
                    <small className='ms-3'><i>*Durch Absenden des Formlars erklären Sie sich damit einverstanden,
                        dass wir Ihre personenbezogenen Daten verarbeiten und speichern dürfen.</i></small>
                    <Summary />
                </div> : <Forms />
            }
            <DetailModel />
        </section>
        );
}
